import { ButtonProps, Flex, Text } from '@chakra-ui/react';
import { MouseEvent } from 'react';
import Avatar from '~/components/Avatar';
import Button from '~/components/Button';
import { IconBox } from '~/components/IconBox';
import { CrossIcon } from '~/components/icons';
import { getMainPlatformData } from '~/core/utils';
import { ICreator } from '~/types';
import { convertPxToRems } from '~/utils-ts';

interface Props extends ButtonProps {
  creator: ICreator;
  onRemoveIconClick: (event: MouseEvent) => void;
  trackId?: string;
}

export const CreatorPill: React.FC<Props> = ({
  creator,
  onRemoveIconClick,
  trackId,
  ...props
}) => {
  const { avatar, name = 'Creator' } = getMainPlatformData(creator);

  return (
    <Button
      background="primary.50"
      aria-label="filter by creator"
      paddingRight={1.5}
      paddingLeft={0.5}
      paddingY={1}
      width="auto"
      borderColor="secondary.500"
      borderWidth={convertPxToRems(2)}
      track-id={trackId}
      {...props}
    >
      <Avatar src={avatar} width={8} height={8} />
      <Text as="span" marginLeft={2} fontWeight="medium" fontSize="sm">
        {name}
      </Text>
      <Flex
        marginLeft={1}
        padding={1}
        _hover={{
          backgroundColor: 'primary.200',
          rounded: 'full',
        }}
        justifyContent="center"
        alignItems="center"
        onClick={onRemoveIconClick}
        role="button"
      >
        <IconBox
          boxSize={4}
          icon={
            <CrossIcon boxSize={2.5} color="primary.300" cursor="pointer" />
          }
        />
      </Flex>
    </Button>
  );
};
